<template>
  <v-form
    
    ref='alergiesForm'>
    <v-card
      v-for="(alergy, i) in user.health.alergies"
      v-bind:key="i"
      class=condCard>

      <v-text-field
        v-model="user.health.alergies[i].name"
        label="What is the medication you are allergic to?"></v-text-field>

      <v-text-field
        v-model="user.health.alergies[i].reaction"
        label="What reaction do you have to this medication?"></v-text-field>

      <v-btn
        right
        depressed
        class="right white--text"
        color="red"
        @click="remove(i)">
        Remove
      </v-btn>
    </v-card>
    <center>
      <v-btn
        class="padded white--text"
        color="green"
        @click="addAlergy">
        Add allergy
      </v-btn>
    </center>
  </v-form>
</template>


<script>
import { mapFields } from "vuex-map-fields";
export default {
  props: {
  },
  mounted () {
  },
  methods: {
    remove (index) {
      if (index >= 0) {
        this.user.health.alergies.splice(index, 1);
      }
    },
    addAlergy() {
      var alergy = {
        name: '',
        reaction: ''
      };
      this.user.health.alergies.push(alergy);
    }
  },
  data () {
    return {

    };
  },
  computed: {
    ...mapFields("patientQuestion", [
      "dataModel",
    ]),
    ...mapFields([
      "user"
    ])
  }
};
</script>
<style>
.condCard {
  padding: 20px;
  margin: 5px;
}
.padded {
  margin: 5px 5px 5px 5px;
}
</style>
